/**
 *
 * CollaboratorsEditTemplate
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
/* eslint-disable react/prefer-stateless-function */
import "../CollaboratorsCreateTemplate/index.less"
import ModalCustom from "components/ModalCustom"
import ModalAmbassadorAssign from "components/ModalAmbassadorAssign"
import ModalAmbassadorDelete from "components/ModalAmbassadorDelete"
import "./index.less"
import {
  Divider,
  Input,
  Checkbox,
  Select,
  Button,
  Popover,
  Tabs,
  List,
  Spin,
  DatePicker,
} from "antd"
import moment from "moment"
import { isEqual, range, truncate, flatMap, pick } from "lodash"
import { LeftOutlined, MinusCircleFilled, UserAddOutlined } from "@ant-design/icons"
import SelectorHR from "components/Select"
import alertSvg from "../../images/alert.svg"
import deleteSvg from "../../images/delete.svg"
import editSvg from "../../images/edit-icon.svg"
import { isModuleBySlug, LOCAL_COMPANY_ID, LOCAL_VISMA_PEOPLE_SYNC_ENABLED } from "../../utils/storage"
import { AMBASSADOR_USERS } from "../../utils/constants"

const MONTHS = [
  { name: "Enero", month: "01" },
  { name: "Febrero", month: "02" },
  { name: "Marzo", month: "03" },
  { name: "Abril", month: "04" },
  { name: "Mayo", month: "05" },
  { name: "Junio", month: "06" },
  { name: "Julio", month: "07" },
  { name: "Agosto", month: "08" },
  { name: "Septiembre", month: "09" },
  { name: "Octubre", month: "10" },
  { name: "Noviembre", month: "11" },
  { name: "Diciembre", month: "12" },
]

const InputGroup = Input.Group
const { Option } = Select

class CollaboratorsEditTemplate extends React.Component {
  constructor() {
    super()
    this.onChange = this.onChange.bind(this)
    this.saveAttributesSegment = this.saveAttributesSegment.bind(this)
  }

  state = {
    tab: "1",
    first_name: "",
    last_name: "",
    second_last_name: "",
    document: "",
    date_birth: "",
    date_admission: "",
    id_gender: "",
    id_division: "",
    position_name: "",
    email: "",
    id_currency: 1,
    id_position_level: "",
    id_employee_leader: "",
    id_geographic_location: "",
    phone: "",
    // location: "",
    salary: "",
    general_manager: 0,
    infoEditSegment: [],
    errorName: false,
    errorData: false,
    errorDivision: false,
    errorEmail: false,
    errorPosition: false,
    errorDate: false,
    errorDateBirth: false,
    buttonDisabled: true,
    dateBirthSelected: null,
    dateAdmissionSelected: null,
    // For tab user ambassador
    selectedDivision: undefined,
    modalAmbassadorAsign: false,
    modalAmbassadorDelete: false,
    currentAmbassador: {},
    dataBackup: {},
  }

  componentDidMount() {
    const { collaborator } = this.props
    const data = {
      first_name: collaborator.first_name,
      last_name: collaborator.last_name,
      second_last_name: collaborator.second_last_name,
      document: collaborator.document,
      // date_birth: collaborator.date_birth,
      id_gender: collaborator.id_gender,
      id_geographic_location: collaborator.id_geographic_location,
      id_division: collaborator.activepositions[0].id_division,
      position_name: collaborator.activepositions[0].name,
      email: collaborator.email,
      id_currency: collaborator.activepositions[0].id_currency,
      id_position_level: collaborator.activepositions[0].position_level,
      phone: collaborator.phone,
      // location: collaborator.activepositions[0].location,
      salary: collaborator.activepositions[0].salary,
      general_manager: collaborator.activepositions[0].general_manager,
      id_employee_leader:
        collaborator.id_employee_parent == 0
          ? ""
          : collaborator.id_employee_parent,
      dateBirthSelected: collaborator.date_birth || null,
      dateAdmissionSelected: collaborator.date_admission || null,
    }
    this.setState({
      ...JSON.parse(JSON.stringify(data)),
      dataBackup: JSON.parse(JSON.stringify(data)),
      dateBirthSelected: collaborator.date_birth ? moment(collaborator.date_birth, "YYYY-MM-DD") : null,
      dateAdmissionSelected: collaborator.date_admission ? moment(collaborator.date_admission, "YYYY-MM-DD") : null,
    })
  }

  hasChanges = () => {
    const { dataBackup, dateAdmissionSelected, dateBirthSelected } = this.state
    const currentState = pick(this.state, [
      "first_name",
      "last_name",
      "second_last_name",
      "document",
      "id_gender",
      "id_geographic_location",
      "id_division",
      "position_name",
      "email",
      "id_currency",
      "id_position_level",
      "phone",
      // "location",
      "salary",
      "general_manager",
      "id_employee_leader",
    ])
    // Comparar las fechas por separado (moment vs string)
    const currentDateBirth = dateBirthSelected ? dateBirthSelected.format("YYYY-MM-DD") : null
    const backupDateBirth = dataBackup.dateBirthSelected || null
    if (currentDateBirth !== backupDateBirth) {
      return true
    }
    const currentDateAdmission = dateAdmissionSelected ? dateAdmissionSelected.format("YYYY-MM-DD") : null
    const backupDateAdmission = dataBackup.dateAdmissionSelected || null
    if (currentDateAdmission !== backupDateAdmission) {
      return true
    }
    const backupWithoutDates = { ...dataBackup }
    delete backupWithoutDates.dateAdmissionSelected
    delete backupWithoutDates.dateBirthSelected
    if (!isEqual(currentState, backupWithoutDates)) {
      return true
    }
    return false
  }

  saveAttributesSegment(name, value) {
    const { collaborator } = this.props
    const { infoEditSegment } = this.state
    const valueOriginal = collaborator[name]
    /* find the index of the name in array of type values */
    const index = infoEditSegment.indexOf(name)
    /* Change in the input */
    if (valueOriginal != value && index == -1) {
      infoEditSegment.push(name)
    } else {
      /* Same value , also It works when the data is restarted */
      if (
        (valueOriginal === value && index != -1) ||
        (value === "" && typeof valueOriginal === "undefined")
      ) {
        infoEditSegment.splice(index, 1)
      }
    }
    this.setState({ infoEditSegment })
  }

  onUpdate = () => {
    const {
      first_name,
      last_name,
      second_last_name,
      document,
      date_birth,
      id_gender,
      id_geographic_location,
      id_division,
      id_currency,
      phone,
      salary,
      position_name,
      email,
      id_position_level,
      general_manager,
      location,
      date_admission,
      id_employee_leader,
      infoEditSegment,
    } = this.state

    let {
      errorName,
      errorData,
      errorDivision,
      errorPosition,
      errorDate,
      errorDateBirth,
      errorEmail
    } = false

    if (!this.state.dateAdmissionSelected) {
      errorDate = true
    }

    if (!this.state.dateBirthSelected) {
      errorDateBirth = true
    }

    if (first_name.length == 0 || last_name.length == 0) {
      errorName = true
    }

    if (document.length == 0 || id_gender.length == 0) {
      errorData = true
    }

    if (id_division.length == 0) {
      errorDivision = true
    }

    if (position_name.length == 0) {
      errorPosition = true
    }
    if(email.length == 0 && this.props.collaborator.is_user ) {
      errorEmail = true
    }

    this.setState(
      {
        errorName,
        errorData,
        errorDivision,
        errorPosition,
        errorDate,
        errorDateBirth,
        errorEmail,
      },
      () => {
        const check = this.checkInputs()

        if (check) {
          const params = {
            first_name,
            last_name,
            second_last_name,
            document,
            date_birth: this.state.dateBirthSelected ? this.state.dateBirthSelected.format("YYYY-MM-DD") : "",
            id_gender,
            id_geographic_location,
            id_division,
            position_name,
            email,
            id_currency,
            id_position_level,
            phone,
            // location,
            salary,
            date_admission: this.state.dateAdmissionSelected ? this.state.dateAdmissionSelected.format("YYYY-MM-DD") : "",
            general_manager: general_manager ? 1 : 0,
            id_company: LOCAL_COMPANY_ID(),
            id_employee_leader:
              typeof id_employee_leader === "undefined"
                ? ""
                : id_employee_leader ||
                  this.props.collaborator.id_employee_parent,
          }
          const payload = {
            params,
            id: this.props.collaboratorId,
            infoEditSegment,
          }
          this.props.updateCollaborator(payload)
        }
      }
    )
  }

  onChangeCheckbox = (e) => {
    this.setState({
      general_manager: e.target.checked,
      buttonDisabled: false,
    })
  }

  onKeyUpClean = (option) => {
    const {
      first_name,
      last_name,
      second_last_name,
      document,
      date_birth,
      date_admission,
      id_gender,
      id_division,
      id_currency,
      position_name,
      email,
      id_position_level,
    } = this.state

    switch (option) {
      case 1:
        if (first_name.length == 0 || last_name.length == 0) {
          this.setState({
            errorName: true,
            disabledButton: true,
          })
        } else {
          this.setState({
            errorName: false,
            disabledButton: false,
          })
        }
        break
      case 2:
        if (document.length == 0 || id_gender.length == 0) {
          this.setState({
            errorData: true,
            disabledButton: true,
          })
        } else {
          this.setState({
            errorData: false,
            disabledButton: false,
          })
        }
        if (!this.state.dateBirthSelected) {
          this.setState({
            errorDateBirth: true,
            disabledButton: true,
          })
        } else {
          this.setState({
            errorDateBirth: false,
            disabledButton: false,
          })
        }
        break
      case 3:
        if (id_division.length == 0) {
          this.setState({
            errorDivision: true,
            disabledButton: true,
          })
        } else {
          this.setState({
            errorDivision: false,
            disabledButton: false,
          })
        }
        break
      case 4:
        /*  if(id_position_level.length == 0) {
           this.setState({
             disabledButton: true
           })
         } else {
           this.setState({
             disabledButton: false
           })
         } */
        break
      case 5:
        if (email.length == 0) {
          this.setState({ disabledButton: true })
          if (this.props.collaborator.is_user) {
            this.setState({
              errorEmail: true,
            })
          }
        } else {
          this.setState({ disabledButton: false })
          this.setState({
            errorEmail: false,
          })
        }
        break
      case 6:
        if (position_name.length == 0) {
          this.setState({
            errorPosition: true,
            disabledButton: true,
          })
        } else {
          this.setState({
            errorPosition: false,
            disabledButton: false,
          })
        }
        break
      case 7:
        if (!this.state.dateAdmissionSelected) {
          this.setState({
            errorDate: true,
            disabledButton: true,
          })
        } else {
          this.setState({
            errorDate: false,
            disabledButton: false,
          })
        }
        break
    }
  }

  checkInputs = () => {
    const { errorName, errorData, errorDivision, errorPosition,errorEmail } = this.state

    if (!errorName && !errorData && !errorDivision && !errorPosition && !errorEmail) {
      return true
    }
    return false
  }

  onChange(date, dateString) {
    this.setState(
      {
        date_birth: dateString,
        buttonDisabled: false,
      },
      () => {
        this.onKeyUpClean(2)
      }
    )
  }

  onChangeDate(name, value, key) {
    this.saveAttributesSegment(name, value)
    this.setState(
      {
        [name]: value,
        buttonDisabled: false,
      },
      () => {
        this.onKeyUpClean(key)
      }
    )
  }

  onChangeInput = (name, value) => {
    this.saveAttributesSegment(name, value)
    this.setState({
      [name]: value,
      buttonDisabled: false,
    })
  }

  onSelectChange = (name, value) => {
    this.saveAttributesSegment(name, value)
    if (typeof value === "undefined") {
      this.setState({
        [name]: name === "id_employee_leader" ? undefined : "",
        buttonDisabled: false,
      })
    } else {
      this.setState(
        {
          [name]: value,
          buttonDisabled: false,
        },
        () => {
          switch (name) {
            case "id_gender":
              this.onKeyUpClean(2)
              break
            case "id_division":
              this.onKeyUpClean(3)
              break
          }
        }
      )
    }
  }

  daysInMonth = () => {
    const { monthSelected, yearSelected, daySelected } = this.state

    if (monthSelected && yearSelected) {
      const daysMonth = new Date(yearSelected, monthSelected, 0).getDate()

      if (daysMonth < Number(daySelected)) {
        this.setState({ daySelected: daysMonth })
      }

      return daysMonth
    }

    // Cuando no hay mes/año seleccionados, mostrar 31 días para
    // permitir seleccionar del 1 al 31 sin depender del mes actual.
    return 31
  }

  daysInMonthWork = () => {
    const {
      monthEntrySelected,
      yearEntrySelected,
      dayEntrySelected,
    } = this.state

    if (monthEntrySelected && yearEntrySelected) {
      const daysMonth = new Date(
        yearEntrySelected,
        monthEntrySelected,
        0
      ).getDate()

      if (daysMonth < Number(dayEntrySelected)) {
        this.setState({ dayEntrySelected: daysMonth })
      }

      return daysMonth
    }

    // Para la fecha de ingreso aplicamos el mismo criterio.
    return 31
  }

  renderUser = () => {
    const { divisions, collaborator } = this.props
    const { selectedDivision } = this.state
    const idDivisionAmbassador = flatMap(
      collaborator.division_ambassadors,
      (item) => item.id_division
    )
    const listMeditionsToAdd = divisions.filter(
      (d) => !idDivisionAmbassador.includes(d.id_division)
    )
    return (
      <Fragment>
        <div style={{ paddingTop: "2rem" }}>
          <b>Embajador de Clima Laboral y Engagement</b>
          <p style={{ marginTop: 10 }}>
            Asigna al colaborador como <b>embajador</b> de una división para que
            pueda ejecutar planes de acción con el objetivo de mejorar su{" "}
            <b>Clima Laboral</b> y <b>Engagement</b>. El usuario tendrá
            visibilidad de los resultados de la división a la que es asignado, y
            las divisiones debajo.
            <br />
            Es posible asignar más de un embajador por división, y más de una
            división por embajador.
          </p>
        </div>
        <div style={{ display: "flex" }}>
          <SelectorHR
            placeholder="Seleccionar división"
            options={listMeditionsToAdd}
            labelKey="id_division"
            label="name"
            value={selectedDivision}
            allowClear
            onChange={(selectedDivision) => this.setState({ selectedDivision })}
          />
          <Button
            disabled={!selectedDivision}
            onClick={() => this.setState({ modalAmbassadorAsign: true })}
            type="primary"
            style={{ marginLeft: 10 }}>
            Asignar
          </Button>
        </div>
        {collaborator.division_ambassadors.length > 0 && (
          <div style={{ marginTop: 16 }}>
            <span style={{ margin: "12px 0", display: "block" }}>
              {collaborator.division_ambassadors.length}{" "}
              {collaborator.division_ambassadors.length > 1
                ? "divisiones asignadas"
                : "división asignada"}
            </span>
            <div>
              <List
                className="listSubdivisions"
                size="small"
                loading={false}
                bordered
                dataSource={collaborator.division_ambassadors}
                renderItem={(item) => {
                  return (
                    <List.Item>
                      <span>{truncate(item.name, { length: 72 })}</span>
                      <MinusCircleFilled
                        onClick={() =>
                          this.setState({
                            modalAmbassadorDelete: true,
                            currentAmbassador: {
                              id_ambassador: item.id_ambassador,
                              first_name: collaborator.first_name,
                              id_division: item.id_division,
                              divisions: [
                                {
                                  id_division: item.id_division,
                                  name: item.name,
                                },
                              ],
                            },
                          })
                        }
                      />
                    </List.Item>
                  )
                }}
              />
            </div>
          </div>
        )}
      </Fragment>
    )
  }

  getMinHeight = () => {
    if (this.state.tab === "2") {
      return `calc(100vh - ${document.querySelector(
        ".collaborators-container-box"
      ).offsetTop + 32}px)`
    }
    return "auto"
  }

  render() {
    const {
      divisions,
      currency,
      categories,
      collaborator,
      leaders,
      genders,
      locations,
    } = this.props
    const {
      errorName,
      errorData,
      errorDivision,
      errorPosition,
      buttonDisabled,
      errorDate,
      errorDateBirth,
      selectedDivision,
      modalAmbassadorAsign,
      tab,
      modalAmbassadorDelete,
      currentAmbassador,
      errorEmail
    } = this.state

    const redDot = () => <span className="red-dot">*</span>

    const selectAfter = (
      <Select
        defaultValue={collaborator.activepositions[0].id_currency}
        onChange={(e) => this.onSelectChange("id_currency", e)}>
        {/*currency.map((currency) => (
          <Option key={currency.id_currency} value={currency.id_currency}>
            {currency.symbol}
          </Option>
        ))*/}
      </Select>
    )
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <div className="collaborators-container">
        <div
          className="collaborators-update-header"
          style={{ display: "block", background: "white", paddingBottom: 0 }}>
          <div style={{ display: "flex" }}>
            <div>
              <div
                className="collaborators-container-btn-back"
                style={{ marginBottom: 12 }}>
                <span
                  onClick={() => {
                    if (this.hasChanges()) {
                      this.setState({ modalBackOpen: true })
                    } else {
                      this.props.history.push("/organization#collaborators")
                    }
                  }}>
                  <LeftOutlined /> Colaboradores
                </span>
              </div>
              <span className="subtitle">
                Editar información de{" "}
                <strong style={{ fontWeight: "600" }}>
                  {collaborator.full_name}
                </strong>
              </span>
            </div>
            {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
              <Button
                onClick={() => {
                  this.props.getMeasures(collaborator.id_employee)

                  this.setState({ modalDeleteCollaborators: true })
                }}
                type="primary"
                className="removeCollaboratorButton">
                <img src={deleteSvg} />
                Eliminar
              </Button>
            )}
          </div>

          <div style={{ margin: "5px -16px 0", height: 43, width: "100%" }}>
            <Tabs
              defaultActiveKey="1"
              animated={false}
              onChange={(key) => this.setState({ tab: key })}
              tabBarStyle={{ border: 0 }}>
              <Tabs.TabPane tab="Información" key="1" />
              {this.props.collaborator.email != "" && isAmbassador ? (
                <Tabs.TabPane tab="Usuario" key="2" />
              ) : null}
            </Tabs>
          </div>
        </div>
        <div
          className="collaborators-container-box" style={{minHeight: this.getMinHeight(), ...(typeof window.Intercom !== "undefined" &&
            window.self === window.top && {
            paddingBottom: "16px!important"}) }}>
          {tab === "1" ? (
            <Fragment>
              {LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
                <div className="collaborators-visma-people-banner">
                  <p className="collaborators-visma-people-banner-wrapper">
                    <img src={editSvg} />
                    <span className="collaborators-visma-people-banner-text">
                      Ingresa a Visma People para realizar <b>cambios sobre los campos bloqueados</b>. Estos serán reflejados una vez que la plataforma reprocese estos datos.
                    </span>
                    <Button onClick={() => {
                      window.open("https://people.vismalatam.com", "_blank")
                    }}>
                      Ir a Visma People
                    </Button>
                  </p>
                </div>
              )}
              <div className="collaborators-container-box-divider">
                <span className="collaborators-container-box-divider-tittle">
                  INFORMACIÓN PERSONALS
                </span>
                <Divider />
              </div>

              <div className="inputNameContainer">
                {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() ? (
                  <>
                    <div className="title-with-error">
                    <h4>
                      Nombre y Apellido
                      {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && redDot()}
                    </h4>
                    {errorName && <div>Campos obligatorios</div>}
                  </div>
                  <InputGroup compact>
                    <Input
                      maxLength={80}
                      style={{ width: "33.3%" }}
                      onChange={(e) =>
                        this.onChangeInput("first_name", e.target.value)
                      }
                      placeholder="Nombre"
                      onKeyUp={() => this.onKeyUpClean(1)}
                      defaultValue={collaborator.first_name}
                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    />
                    <Input
                      onKeyUp={() => this.onKeyUpClean(1)}
                      maxLength={60}
                      style={{ width: "33.3%" }}
                      onChange={(e) =>
                        this.onChangeInput("last_name", e.target.value)
                      }
                      placeholder="Apellido paterno"
                      defaultValue={collaborator.last_name}

                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    />
                    <Input
                      onKeyUp={() => this.onKeyUpClean(1)}
                      maxLength={60}
                      style={{ width: "33.3%" }}
                      onChange={(e) =>
                        this.onChangeInput("second_last_name", e.target.value)
                      }
                      placeholder="Apellido materno"
                      defaultValue={collaborator.second_last_name}
                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    />
                  </InputGroup>
                  </>
                ) : <>
                  <div className="inputNameContainerSeparated">
                    <div className="inputName">
                      <h4>
                        Nombres
                      </h4>
                      <Input
                        maxLength={80}
                        placeholder="Nombres"
                        defaultValue={collaborator.first_name}
                        disabled={true}
                      />
                    </div>
                    <div className="inputName">
                      <h4>
                        Apellido Paterno
                      </h4>
                      <Input
                        maxLength={60}
                        placeholder="Apellido Paterno"
                        defaultValue={collaborator.last_name}
                        disabled={true}
                      />
                    </div>
                    <div className="inputName">
                      <h4>
                        Apellido Materno
                      </h4>
                      <Input
                        maxLength={60}
                        placeholder="Apellido Materno"
                        defaultValue={collaborator.second_last_name}
                        disabled={true}
                      />
                    </div>
                  </div>
                </>}
              </div>

              <div className="personal-data-container">
                <div className="inputs-grid">
                  <div className="inputName">
                    <h4>
                      DNI
                      {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && <span>*</span>}
                    </h4>
                    <Input
                      maxLength={125}
                      placeholder="DNI"
                      onChange={(e) =>
                        this.onChangeInput("document", e.target.value)
                      }
                      onKeyUp={() => this.onKeyUpClean(2)}
                      defaultValue={collaborator.document}
                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    />
                  </div>
                  <div className="inputName">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5em" }}>
                      <h4>
                        Fecha de nacimiento
                        {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && <span>*</span>}
                      </h4>
                      {errorDateBirth && (
                        <span className="laboral-info-item-error">
                          Campo obligatorio
                        </span>
                      )}
                    </div>
                    <DatePicker
                      format="DD/MM/YYYY"
                      placeholder="Fecha de nacimiento"
                      style={{ width: "100%" }}
                      value={this.state.dateBirthSelected}
                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                      disabledDate={(current) => current && current > moment().endOf("day")}
                      onChange={(date) => {
                        this.saveAttributesSegment("dateBirthSelected", date)
                        this.setState(
                          {
                            dateBirthSelected: date,
                            buttonDisabled: false,
                          },
                          () => this.onKeyUpClean(2)
                        )
                      }}
                    />
                  </div>
                  <div className="inputName">
                    <h4>
                      Género
                      {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && <span>*</span>}
                    </h4>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar"
                      onChange={(e) => this.onSelectChange("id_gender", e)}
                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                      defaultValue={collaborator.id_gender}>
                      {genders.map((gender) => (
                        <Option value={gender.id_gender} key={gender.id_gender}>
                          {gender.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
                {errorData && (
                  <div className="required-field-error">
                    Campos obligatorios
                  </div>
                )}
              </div>
              <div className="collaborators-container-box-divider">
                <span className="collaborators-container-box-divider-tittle">
                  INFORMACIÓN LABORAL
                </span>
                <Divider />
              </div>
              {collaborator.has_leader ? (
                <Popover
                  trigger="hover"
                  content={
                    <div style={{ width: 250 }}>
                      No es posible establecer como Gerente General a
                      colaboradores con un líder asignado.
                    </div>
                  }
                  className="collaborators-container-checkbox">
                  <Checkbox
                    onClick={() =>
                      this.setState({
                        modalCheck: true,
                        buttonDisabled: false,
                      })
                    }
                    disabled={collaborator.has_leader}
                    defaultChecked={
                      collaborator.activepositions[0].general_manager
                    }
                    checked={this.state.general_manager}
                  />
                  <div>
                    Seleccionar como <strong>Gerente General</strong>
                  </div>
                </Popover>
              ) : (
                <div className="collaborators-container-checkbox">
                  <Checkbox
                    onClick={() =>
                      this.setState({
                        modalCheck: true,
                        buttonDisabled: false,
                      })
                    }
                    disabled={collaborator.has_leader}
                    defaultChecked={
                      collaborator.activepositions[0].general_manager
                    }
                    checked={this.state.general_manager}
                  />
                  <div>
                    Seleccionar como <strong>Gerente General</strong>
                  </div>
                </div>
              )}
              <div className="laboral-info-container">
                <div className="laboral-info-item">
                  <div className="laboral-info-item-header">
                    <h4>
                      División
                      {redDot()}
                    </h4>
                    {errorDivision && (
                      <span className="laboral-info-item-error">
                        Campo obligatorio
                      </span>
                    )}
                  </div>
                  <Select
                    style={{ width: "100%" }}
                    allowClear
                    placeholder="Seleccionar división"
                    defaultValue={collaborator.activepositions[0].id_division}
                    showSearch
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}
                    onChange={(e) => {
                      this.onSelectChange("id_division", e)
                    }}>
                    {divisions.map((division) => (
                      <Option
                        key={division.id_division}
                        value={division.id_division}>
                        {division.name}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="laboral-info-item">
                  <div className="laboral-info-item-header">
                    <h4>
                      Puesto
                      {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && redDot()}
                    </h4>
                    {errorPosition && (
                      <span className="laboral-info-item-error">
                        Campo obligatorio
                      </span>
                    )}
                  </div>
                  <Input
                    maxLength={160}
                    placeholder="Ejemplo: Analista de Contabilidad"
                    disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    defaultValue={collaborator.activepositions[0].name}
                    onChange={(e) =>
                      this.onChangeInput("position_name", e.target.value)
                    }
                    onKeyUp={() => this.onKeyUpClean(6)}
                  />
                </div>
                <div className="laboral-info-item">
                  <div className="laboral-info-item-header">
                    <h4>Categoría jerárquica</h4>
                  </div>
                  <Select
                    style={{ width: "100%" }}
                    allowClear
                    placeholder="Seleccionar categoría"
                    disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    defaultValue={
                      collaborator.activepositions[0].position_level
                    }
                    showSearch
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}
                    onChange={(e) =>
                      this.onSelectChange("id_position_level", e)
                    }>
                    {categories.map((category) => (
                      <Option
                      key={category.id_position_level}
                      value={category.id_position_level}>
                      {category.name}
                      </Option>
                    ))}
                    </Select>
                    </div>
                    <div className="laboral-info-item">
                    <div className="laboral-info-item-header">
                      <h4>Correo
                      {collaborator.is_user &&(!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && redDot())}
                      </h4>
                      {errorEmail &&  collaborator.is_user &&(
                      <span className="laboral-info-item-error">
                      Campo obligatorio
                      </span>
                      )}
                    </div>
                    <Input
                      maxLength={100}
                      placeholder="ejemplo@ejemplo.com"
                      onKeyUp={() => this.onKeyUpClean(5)}
                      defaultValue={collaborator.email}
                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                      onChange={(e) =>
                      this.onChangeInput("email", e.target.value)
                      }
                    />
                    </div>
                    <div className="laboral-info-item">
                    <div className="laboral-info-item-header">
                    <h4>
                      Fecha de ingreso
                      {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && redDot()}
                    </h4>
                    {errorDate && (
                      <span className="laboral-info-item-error">
                      Campo obligatorio
                      </span>
                    )}
                  </div>
                  <DatePicker
                    format="DD/MM/YYYY"
                    placeholder="Fecha de ingreso"
                    style={{ width: "100%" }}
                    value={this.state.dateAdmissionSelected}
                    disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    disabledDate={(current) => current && current > moment().endOf("day")}
                    onChange={(date) => {
                      this.saveAttributesSegment("dateAdmissionSelected", date)
                      this.setState(
                        {
                          dateAdmissionSelected: date,
                          buttonDisabled: false,
                        },
                        () => this.onKeyUpClean(7)
                      )
                    }}
                  />
                </div>
                <div className="laboral-info-item">
                  <div className="laboral-info-item-header">
                    <h4>Líder</h4>
                  </div>
                  <Select
                    style={{ width: "100%" }}
                    allowClear
                    placeholder="Seleccionar líder"
                    showSearch
                    disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                    defaultValue={
                      collaborator.id_employee_parent == 0
                        ? ""
                        : collaborator.id_employee_parent
                    }
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}
                    onChange={(e) => {
                      this.onSelectChange("id_employee_leader", e)
                    }}>
                    {leaders.map((leader) => {
                      return (
                        <Option
                          key={leader.id_employee}
                          value={leader.id_employee}>
                          {leader.full_name}
                        </Option>
                      )
                    })}
                  </Select>
                </div>
              </div>
              <div className="laboral-info-input-group">
                <div style={{ maxWidth: "70%" }}>
                  <div className="laboral-info-input-group-tittles">
                    <span>Ubicación geográfica</span>
                  </div>
                  <InputGroup compact>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar ubicación geográfica"
                      disabled={LOCAL_VISMA_PEOPLE_SYNC_ENABLED()}
                      defaultValue={
                        collaborator.id_geographic_location === ""
                          ? null
                          : Number(collaborator.id_geographic_location)
                      }
                      onChange={(e) => {
                        this.onSelectChange("id_geographic_location", e)
                      }}>
                      {locations.map((location) => {
                        return (
                          <Option
                            key={location.id_group}
                            value={location.id_group}>
                            {location.name}
                          </Option>
                        )
                      })}
                    </Select>
                  </InputGroup>
                </div>
                <div style={{ display: "grid" }}>
                  <div className={`create-end-buttons ${hasFreshchat ? "buttonsFooterMarginC" : ""}`}>
                    <Button
                      type="ghost"
                      className="buttonRetry"
                      onClick={() =>
                        this.props.history.push("/organization#collaborators")
                      }>
                      Cancelar
                    </Button>
                    <Button
                      type="primary"
                      loading={this.props.isUpdating}
                      disabled={!this.hasChanges()}
                      onClick={this.onUpdate}>
                      Guardar
                    </Button>
                  </div>
                </div>
              </div>
            </Fragment>
          ) : (
            this.renderUser()
          )}
        </div>
        <ModalCustom
          modalOpen={this.state.modalCheck}
          showFooter
          onOk={() =>
            this.setState({
              modalCheck: false,
              general_manager: !this.state.general_manager,
            })
          }
          onCancel={() => this.setState({ modalCheck: false })}>
          <img src={alertSvg} className="alertIcon" alt="alert-svg" />
          {this.state.general_manager ? (
            <span style={{ fontSize: 14 }}>
              ¿Estás seguro de que deseas desasignar a{" "}
              <strong style={{ fontWeight: 600 }}>
                {collaborator.full_name}
              </strong>{" "}
              como Gerente General?
            </span>
          ) : (
            <span style={{ fontSize: 14 }}>
              ¿Estás seguro de que deseas seleccionar a{" "}
              <strong style={{ fontWeight: 600 }}>
                {collaborator.full_name}
              </strong>{" "}
              como Gerente General?
            </span>
          )}
        </ModalCustom>
        <ModalCustom
          showFooter
          modalOpen={this.state.modalBackOpen}
          onOk={() => this.props.history.push("/organization#collaborators")}
          onCancel={() => this.setState({ modalBackOpen: false })}>
          <img src={alertSvg} className="alertIcon" alt="alert-svg" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            ¿Estás seguro de que deseas salir sin guardar los cambios?
          </span>
        </ModalCustom>
        <ModalCustom
          modalOpen={this.state.modalDeleteCollaborators}
          showFooter={!this.props.isLoadingMeasures}
          onCancel={() => this.setState({ modalDeleteCollaborators: false })}
          onOk={() => {
            this.props.removeCollaborator(collaborator.id_employee)
          }}>
          {this.props.isLoadingMeasures && (
            <Spin
              spinning
              size="large"
              className="collaborators-delete-modal-load-spin"
            />
          )}

          {!this.props.isLoadingMeasures && (
            <img src={alertSvg} className="alertIcon" />
          )}

          {!this.props.isLoadingMeasures && (
            <span>
              <span style={{ fontSize: 14, fontWeight: 600 }}>
                ¿Estás seguro de que deseas eliminar a{" "}
                <strong style={{ fontWeight: "600" }}>
                  {collaborator.full_name}
                </strong>
                ?
              </span>

              {this.props.measuresAffected.length > 0 && (
                <p style={{ fontSize: 13, marginTop: 8 }}>
                  Se <b>eliminarán</b> tambien sus respuestas en las mediciones
                  que
                  <br /> participó, que aún no han sido oficializadas:
                  <br />
                  <br />
                  {this.props.measuresAffected.map((measure, index) => {
                    return (
                      <span key={index}>
                        {measure.name}
                        <br />
                      </span>
                    )
                  })}
                </p>
              )}

              <p style={{ fontSize: 13, marginTop: 8 }}>
                La acción <b>no será reversible</b>
                {this.props.measuresAffected.length > 0
                  ? "."
                  : ", y se perderá su historial en el sistema. De ser el caso, deberás asignarle un nuevo líder a su equipo."}
              </p>
            </span>
          )}
        </ModalCustom>

        <ModalAmbassadorAssign
        languages={this.props.languages}
        getLanguage={this.props.getLanguage}
          selectedDivision={selectedDivision}
          selectedEmployee={collaborator}
          open={modalAmbassadorAsign}
          onCancel={() => this.setState({ modalAmbassadorAsign: false })}
          onFinish={(result) => {
            collaborator.division_ambassadors.push({
              id_ambassador: result[0].id_ambassador,
              name: selectedDivision.name,
              id_division: selectedDivision.id_division,
            })
            this.setState({
              modalAmbassadorAsign: false,
              selectedDivision: null,
            })
          }}
        />

        <ModalAmbassadorDelete
          currentAmbassador={currentAmbassador}
          deleteByDivision
          open={modalAmbassadorDelete}
          onCancel={() => {
            this.setState({ modalAmbassadorDelete: false })
          }}
          onFinish={() => {
            const findIndexToDelete = collaborator.division_ambassadors.findIndex(
              (e) =>
                e.id_division === currentAmbassador.divisions[0].id_division
            )
            if (findIndexToDelete > -1) {
              collaborator.division_ambassadors.splice(findIndexToDelete, 1)
            }
            this.setState({ modalAmbassadorDelete: false })
          }}
        />
      </div>
    )
  }
}

CollaboratorsEditTemplate.propTypes = {}

export default CollaboratorsEditTemplate
